export default require('./ChapterPrevious').default
